// extracted by mini-css-extract-plugin
export default {"APIKeyDropdown-details":"APIKeyDropdown-details3u51bDo9mAup","APIKeyDropdown-keys":"APIKeyDropdown-keys3yVEV_HRrvTP","APIKeyDropdown-link":"APIKeyDropdown-link1reXKEYkB1Wp"};